var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.625C36.4647 5.625 42.6645 8.19307 47.2357 12.7643C51.8069 17.3355 54.375 23.5353 54.375 30C54.375 36.4647 51.8069 42.6645 47.2357 47.2357C42.6645 51.8069 36.4647 54.375 30 54.375C23.5353 54.375 17.3355 51.8069 12.7643 47.2357C8.19307 42.6645 5.625 36.4647 5.625 30C5.625 23.5353 8.19307 17.3355 12.7643 12.7643C17.3355 8.19307 23.5353 5.625 30 5.625ZM30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60ZM43.2422 24.4922C44.3437 23.3906 44.3437 21.6094 43.2422 20.5195C42.1406 19.4297 40.3594 19.418 39.2695 20.5195L26.2617 33.5273L20.7539 28.0195C19.6523 26.918 17.8711 26.918 16.7812 28.0195C15.6914 29.1211 15.6797 30.9023 16.7812 31.9922L24.2812 39.4922C25.3828 40.5937 27.1641 40.5937 28.2539 39.4922L43.2422 24.4922Z",
    fill: "#6BBF59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkgreen);
export default __webpack_public_path__ + "static/media/checkmark green.21b8e65b197ab8c14dd7fad438046bc9.svg";
export { ForwardRef as ReactComponent };